import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PDFDownloadLink} from "@react-pdf/renderer";
import GraficoParticipacion from "./components/GraficoParticipacion";
import InformePDF from "./components/InformePDF";

function StatisticsPage () {
  const [statistics, setStatistics] = useState([]);
  const [message, setMessage] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false); // 👈 estado de login
  const navigate = useNavigate();
  const [chartImage, setChartImage] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');

    if (!token) {
      setMessage('Acceso denegado: No estás autenticado.');
      setIsLoggedIn(false);
      navigate('/login', { state: { from: '/statistics' } });
    }

    try {
      setIsLoggedIn(true); // hay token → marcar sesión activa

      // Obtener statistics desde backend
      /*fetch('https://api.grekad.cfcunap.cl/api/statistics', {
        method: 'GET',
        headers: { Authorization: token },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            console.log("Estadísticas recibidas:", data.statistics);
            setStatistics(data.statistics);
          } else {
            setMessage(data.message || 'Error al obtener el ranking.');
          }
        })
        .catch(() => {
          setMessage('Error en la conexión al servidor.');
        });*/
    } catch (error) {
      setMessage('Token inválido. Por favor, vuelve a iniciar sesión.');
      setIsLoggedIn(false);
      //navigate('/login');
      navigate('/login', { state: { from: '/statistics' } });
    }
  }, [navigate]);
//console.log("Imagen que se pasa al PDF:", chartImage?.substring(0, 50));
  return (
    <div className="mt-3">
            {/* Genera el gráfico oculto y obtiene base64 */}
      
        <GraficoParticipacion 
      onImageReady={setChartImage} />

      {/* Mensajes de error */}
      {message && <p style={{ color: "red" }}>{message}</p>}
      {/* Vista previa (debug)
      {chartImage && (
        <div>
          <h4>Vista previa del gráfico</h4>
          <img src={chartImage} alt="preview grafico" width="200" />
        </div>
      )} */}

      {/* Solo mostrar enlace si hay sesión */}
      {isLoggedIn && (
        <PDFDownloadLink document={<InformePDF chartImage={chartImage} />} fileName="informe_trabajador_destacado_2025.pdf">
          {({ loading }) =>
            loading ? "Generando PDF..." : "📄 Descargar Informe"
          }
        </PDFDownloadLink>
      )}
    </div>
  );
}

export default StatisticsPage;


